import { accessAsset, anyAsset, AssetCategories, AssetUIModel, CanPipe } from '@thehubz/client/core';
import { Asset } from '@thehubz/client/data-access-api';
import { CustomClients } from '@thehubz/shared/branding';
import { AssetMetadata } from './asset-info.interface';

const AccessAsset = accessAsset;
const AnyAsset = anyAsset;

export const assetMetadataConfig = (assetInfo: AssetUIModel, canPipe: CanPipe): AssetMetadata => {
  const status: { id: Asset.StatusEnum; name: string }[] = [
    {
      id: Asset.StatusEnum.Uploaded,
      name: $localize`Uploaded`,
    },
    {
      id: Asset.StatusEnum.AwaitingApproval,
      name: $localize`Awaiting approval`,
    },
  ];
  /**
   * Below condition is used to check whether a user have right to set asset status 'Approved'.
   */
  if (canPipe.transform(AnyAsset, 'update.allstatus')) {
    status.push({
      id: Asset.StatusEnum.Approved,
      name: $localize`Approved`,
    });
  }
  /**
   * Below condition is used to check whether a user have right to set asset status 'Archived'.
   */
  if (canPipe.transform(AnyAsset, 'archived')) {
    status.push({
      id: Asset.StatusEnum.Archived,
      name: $localize`Archived`,
    });
  }
  return {
    customerName: CustomClients.Standard,
    metadata: [
      {
        fieldLabel: $localize`Name`,
        editable: true,
        formControlName: 'name',
      },
      {
        fieldLabel: $localize`Agency`,
        editable: true,
        formControlName: 'agency',
        options: [],
      },
      {
        fieldLabel: $localize`Client`,
        editable: true,
        formControlName: 'client',
        options: [],
      },
      {
        fieldLabel: $localize`Brand`,
        editable: true,
        formControlName: 'brand',
        options: [],
      },
      {
        fieldLabel: $localize`Status`,
        editable: assetInfo && assetInfo.accessKeys ? canPipe.transform(AccessAsset(assetInfo), 'update.allstatus') : true,
        formControlName: 'status',
        options: status,
      },
      {
        fieldLabel: $localize`Job number`,
        editable: true,
        formControlName: 'jobNumber',
      },
      {
        fieldLabel: $localize`Created at`,
        editable: false,
        formControlName: 'createdAt',
        options: [],
      },
      {
        fieldLabel: $localize`:asset medium:Medium`,
        editable: false,
        formControlName: 'medium',
        options: [],
      },
      {
        fieldLabel: $localize`Asset category`,
        editable: false,
        formControlName: 'assetCategory',
        fieldType: 'multiSelect',
        options: AssetCategories,
        customValue: true,
      },
      {
        fieldLabel: $localize`Licensee/Client contact`,
        editable: false,
        formControlName: 'clientContact',
        customValue: true,
      },
      {
        fieldLabel: $localize`Created by`,
        editable: false,
        formControlName: 'createdBy',
        options: [],
      },
      {
        fieldLabel: $localize`Modified at`,
        editable: false,
        formControlName: 'updatedAt',
        options: [],
      },
      {
        fieldLabel: $localize`Modified by`,
        editable: false,
        formControlName: 'updatedBy',
        options: [],
      },
      {
        fieldLabel: $localize`Description`,
        editable: true,
        formControlName: 'description',
        options: [],
      },
      {
        fieldLabel: $localize`Planned for deletion`,
        editable: true,
        formControlName: 'plannedDeletion',
        options: [],
      },
      {
        fieldLabel: $localize`Publish Start Date`,
        editable: assetInfo && assetInfo.accessKeys ? canPipe.transform(AccessAsset(assetInfo), 'update.allstatus') : true,
        formControlName: 'publishStartDate',
      },
      {
        fieldLabel: $localize`Publish End Date`,
        editable: assetInfo && assetInfo.accessKeys ? canPipe.transform(AccessAsset(assetInfo), 'update.allstatus') : true,
        formControlName: 'publishEndDate',
      },
    ],
  };
};
